import React from 'react';
import { useIntl } from 'react-intl';

import { renderWithBreaks } from '@utils/translations';

const CookiesTab = () => {
  const intl = useIntl();

  return (
    <div>
      <h3>{intl.formatMessage({ id: '1. Our Use of Cookies and Web Beacons'})}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Cookies 1/1' }))}
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Cookies 1/1 list' }), 'li')}</ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Cookies 1/2' }))}
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Cookies 1/2 list' }), 'li')}</ul>
    </div>
  );
}

export default CookiesTab;
